import { render } from "./ResetPasswordWithCodeCard.vue?vue&type=template&id=9692c142"
import script from "./ResetPasswordWithCodeCard.vue?vue&type=script&lang=js"
export * from "./ResetPasswordWithCodeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__